import { mapGetters, mapState } from 'vuex';

import { getCountryDisplayName } from '@/utils/common';

import { types } from '@/store/types';

export const displayNameMixin = {
  computed: {
    ...mapState({
      displayNameMixin__locale: types.state.LOCALE
    }),
    ...mapGetters({
      displayNameMixin__localeWithRegion: types.getters.LOCALE_WITH_REGION
    })
  },
  methods: {
    getCountryDisplayName(countryCode) {
      const locale =
        this.displayNameMixin__localeWithRegion || this.displayNameMixin__locale || 'en';

      if (!countryCode) {
        return '';
      }

      return getCountryDisplayName(countryCode.toUpperCase(), locale);
    }
  }
};
